import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRemixCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconRemixCircle"><Path d="M16 8H20.5V3.5" stroke="currentColor"/><Path d="M8 16H3.5V20.5" stroke="currentColor"/><Path d="M3.06201 10.9412C3.58605 6.46958 7.38803 3 12.0004 3C15.2212 3 18.0468 4.69183 19.6371 7.23529L20 8M20.9387 13.0588C20.4147 17.5304 16.6127 21 12.0004 21C8.70397 21 5.82149 19.2278 4.25372 16.5841L4 16" stroke="currentColor"/><Path d="M8 12L16 12" stroke="currentColor"/><Path d="M12 8V16" stroke="currentColor"/></CentralIconBase>;
});

export default IconRemixCircle;
